import { Component } from '@angular/core';
import { NavController, MenuController, Platform } from 'ionic-angular';
import { Auth } from '../../providers/auth';
import { LoadingController } from 'ionic-angular';
import { HomePage } from '../home/home'; 
import { LostPasswordPage } from '../lostpassword/lostpassword'; 
import { RegisterPage } from '../register/register'; 
import { ToastController } from 'ionic-angular';
//import { WorkInProgressPage } from '../workinprogress/workinprogress';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { DataExchanger } from '../../providers/data-exchanger';
import { UserdataModel } from '../../providers/userdata-model';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  host: { '(window:resize)': 'handleResizeEvents($event)', '(load)': 'handleResizeEvents($event)', '(document:keydown)': 'handleKeyboardEvents($event)'}
})

export class LoginPage {
  username: string;
  password: string;
  errorMessage: string;
  loader:any;

  pageWorkInProgressLoaded:boolean=false;
  loginButtonPressedOnce:boolean=false; // To avoid multiple click pressing fast return button

  logoutOk:boolean;

  constructor(public functions: Functions, public platform: Platform, public toastCtrl: ToastController, public userdataModel:UserdataModel, public dataexchanger: DataExchanger, public rubedoSideMenu: MenuController,  public translate: TranslateService, public navCtrl: NavController, public auth: Auth, public loadingCtrl: LoadingController) {
    this.errorMessage = "";
    this.pageWorkInProgressLoaded=false;

    if(this.functions.isInDevelopMode()){
      this.username="efalivene_plr";
      this.password="PwdPer1T3sT";
    }
    
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);

    platform.ready().then((readySource) => {
      if((platform.width()<800 || platform.height()<600) && !this.pageWorkInProgressLoaded){
        this.pageWorkInProgressLoaded=true;
        this.goToWorkInProgressPage();
      }
    });
  }

  ionViewWillEnter(){
    this.functions.initApp();

    //before the page in question becomes active
    this.loginButtonPressedOnce=false;
    this.functions.changeShowSidemenuButtonTo(false);

    // Getting initial booksinfo from db (calculated from table 'books')
    this.dataexchanger.getEmptyBooksinfo().then((response)=>{
      this.functions.emptyBooksinfo=response;
    });

    // This triggers only if start over system is active connecting a default user
    if (this.auth.startOverSystemActive) {
      var nextIndexUserTmp=0;
      this.dataexchanger.getUserPwForStartOver().then((response)=>{
        nextIndexUserTmp=this.functions.nextIndexCircularArray(this.auth.indexStartOverUserCurrentlyLogged,this.auth.usersToSwitchDuringStartOver[this.auth.barbicanIdPcConnected]);
        //console.log("++++nextUser :"+this.auth.usersToSwitchDuringStartOver[nextIndexUserTmp]+" index: "+nextIndexUserTmp);
        this.auth.automaticLoginUser(this.auth.usersToSwitchDuringStartOver[this.auth.barbicanIdPcConnected][nextIndexUserTmp],response).then((response)=>{
          if(response){
            this.auth.indexStartOverUserCurrentlyLogged=nextIndexUserTmp;
            this.userdataModel.resetUserSettingsToDefaultValues();
            this.navCtrl.setRoot(HomePage, { firstAccessAfterLogin: true });
          }
        });
      });

    } 
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  goToRegister(){
    this.navCtrl.push(RegisterPage, {});
  }

  goToLostPassword(){
    this.navCtrl.push(LostPasswordPage, {});
  }

  setLanguage(language){
    this.functions.language=language;
    this.functions.setLanguage();
    this.userdataModel.setSettingsCurrentLanguage(this.functions.language);
  }

  login(username,password){
    this.loginButtonPressedOnce=true;
    if(this.functions.deviceIsOnline()){
      this.presentLoading();

      //0342e5aab7e4b guid anonymous
      
      // First logout. If logout is ok, login again. This is to avoid problems if you're already
      // logged in with session expired or if your logged to kreyon or xtribe

      /* If you are developing, comment where is written the word 'HERE' */
      /*HERE*/ this.logoutOk=false;
      this.auth.logout().then((response)=>{
        var responseString:string;
        responseString=response.toString();
        if(responseString.indexOf('LogoutIsOk')!=-1){
          this.logoutOk=true;
        }else{
          if(responseString.indexOf('User is not logged in')!=-1){
            this.logoutOk=true;
          }   
        }

        if(this.logoutOk){/*HERE*/
          this.auth.login(username,password,false).then((response)=>{
            var responseString:string;
            responseString=response.toString();
            if(responseString.indexOf('loginResIsOk')!=-1){
              this.navCtrl.setRoot(HomePage, { firstAccessAfterLogin: true });
              this.functions.startBgMusic('app_BgMusic');
              this.loader.dismiss();
            }else{
              this.functions.showMessage(this.toastCtrl, this.auth.errorMessage);
              this.loginButtonPressedOnce=false;
              this.loader.dismiss();
            }
          });
        /*HERE*/}else{
          this.functions.showMessage(this.toastCtrl, this.auth.errorMessage);
          this.loginButtonPressedOnce=false;
          this.loader.dismiss();
        }
      });/*HERE*/

    }else{
      this.translate.get('noConnection').subscribe(value => { 
        this.errorMessage = value;
        this.functions.showMessage(this.toastCtrl, this.errorMessage);
      });
    }
  }

  presentLoading() {
    this.translate.get('loading').subscribe(value => { 
      this.loader = this.loadingCtrl.create({
        content: value
      });
      this.loader.present();
    });
  }

  handleResizeEvents(event: KeyboardEvent) {
    if(this.navCtrl.getActive().name=="LoginPage"){
      if((event.target['innerWidth']<800 || event.target['innerHeight']<600) && !this.pageWorkInProgressLoaded){
        this.pageWorkInProgressLoaded=true;
        this.goToWorkInProgressPage();
      }
      this.functions.setScaleForBigScreen();
    }
  }

  handleKeyboardEvents(event: KeyboardEvent) {
    // when enter is pressed, login
    if(this.navCtrl.getActive().name=="LoginPage"){
      if(event.which == 13 && this.loginButtonPressedOnce==false){
        document.getElementById('loginButton').click();
      }
    }
  }
  
  goToWorkInProgressPage(){
    //this.navCtrl.push(WorkInProgressPage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts